module.exports = __webpack_public_path__ + "static/img/floor1-ht1.9655765.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor1-ht1.png
// module id = OosL
// module chunks = 1